module.exports = __webpack_public_path__ + "img/bg.073f2798.jpg";